import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Divider
} from '@mui/material';

const ChatHistoryModal = ({ open, onClose, chat }) => {
    if (!chat) return null;
    const { agent_name, agent_id, date_created, date_updated, chat_data } = chat;

    // Debug log to inspect chat_data
    console.log('ChatHistoryModal chat:', chat);

    let parsedChat = [];
    try {
        if (Array.isArray(chat_data)) {
            parsedChat = chat_data;
        } else if (typeof chat_data === 'string' && chat_data.trim() !== '') {
            const parsed = JSON.parse(chat_data);
            if (Array.isArray(parsed)) {
                parsedChat = parsed;
            } else if (parsed && Array.isArray(parsed.messages)) {
                parsedChat = parsed.messages;
            } else {
                parsedChat = [];
            }
        } else if (chat_data && Array.isArray(chat_data.messages)) {
            parsedChat = chat_data.messages;
        } else {
            parsedChat = [];
        }
    } catch (e) {
        console.warn('Failed to parse chat_data:', chat_data, e);
        parsedChat = [];
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
            <DialogTitle>Chat Details</DialogTitle>
            <DialogContent dividers>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Agent: {agent_name || agent_id}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Created: {date_created ? new Date(date_created).toLocaleString() : ''}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Updated: {date_updated ? new Date(date_updated).toLocaleString() : ''}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Box sx={{ maxHeight: 350, overflowY: 'auto', px: 1 }}>
                    {Array.isArray(parsedChat) && parsedChat.length > 0 ? (
                        parsedChat.map((msg, idx) => (
                            <Box key={idx} sx={{ display: 'flex', justifyContent: msg.role === 'user' ? 'flex-start' : 'flex-end', mb: 1 }}>
                                <Box
                                    sx={{
                                        bgcolor: msg.role === 'user' ? '#f5f5f5' : '#e3f2fd',
                                        color: 'text.primary',
                                        px: 2,
                                        py: 1,
                                        borderRadius: 2,
                                        maxWidth: '70%',
                                        boxShadow: 1,
                                    }}
                                >
                                    <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                                        {/* Show msg.text if present, else msg.content, else JSON */}
                                        {msg.text || msg.content || JSON.stringify(msg)}
                                    </Typography>
                                </Box>
                            </Box>
                        ))
                    ) : (
                        <Typography variant="body2" color="text.secondary">No chat data available.</Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChatHistoryModal;
